import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  height: fit-content;

  background: ${baseTheme.colors.white};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);

  @media ${baseTheme.device.tablet} {
    height: 623px;
    border-radius: 16px;
  }
`
